import { AnimalTags } from './animal-tags';

export default AnimalTags;
